<div class="option-execution dropdown-content-root">
	<div class="dropdown-title">
		<p class="title">{{ 'closeOption.title' | translate }}</p>
		<tui-icon
			class="icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>
	@if (form) {
		<div
			[formGroup]="form"
			class="blocks"
		>
			<div class="block">
				<div class="item">
					<div class="ticker">
						<div class="text">
							{{
								(position()?.option_type === optionTypeEnum.CALL
									? 'closeOption.side.buy'
									: 'closeOption.side.sell'
								) | translate
							}}
						</div>
						<span class="text">
							{{ position()?.option_ticker }}
						</span>
						<span class="text">
							{{ position()?.option_strike | price }}
						</span>
						<span
							class="text"
							highlight
							[isPositive]="position()?.option_type === optionTypeEnum.CALL"
							[isNegative]="position()?.option_type === optionTypeEnum.PUT"
						>
							{{ position()?.option_type | uppercase }}
						</span>
						<span class="text">
							{{ position()?.option_date | date: 'dd.MM.yyyy' }}
						</span>
					</div>
					<span class="value">{{ position()?.qty_available | quantity }}</span>
				</div>
				<div class="item">
					<span class="text">{{ 'closeOption.sharesPerContract' | translate }}</span>
					<span class="text">{{ 'closeOption.pcs' | translate }}</span>
				</div>
			</div>

			<div class="block">
				<app-order-type-select
					class="input"
					[types]="orderTypes"
					[control]="form.get('type')"
				/>

				@if (isSelectedLimitPrice) {
					<app-order-price-input
						label="closeOption.price"
						[control]="form.get('limit_price')"
						[bidPrice]="optionContractDetails()?.results?.last_quote?.bid ?? null"
						[askPrice]="optionContractDetails()?.results?.last_quote?.ask ?? null"
						[isLoading]="isLoadingOptionContractDetails()"
						[step]="0.5"
					/>
				}

				<app-order-qty-input [control]="form.get('qty')" />
			</div>

			<div class="summary">
				<div class="order-summary">
					<div class="item">
						<p class="label">{{ 'closeOption.sum' | translate }}:</p>
						<span class="value">{{ totalSum | price }}</span>
					</div>
					<div class="item">
						<p class="label">{{ 'closeOption.availableMoney' | translate }}:</p>
						<span class="value">{{ alpacaAccount()?.regt_buying_power ?? 0 | price }}</span>
					</div>
				</div>
			</div>

			<div class="btn-wrapper">
				<app-button
					appearance="primary"
					size="l"
					[isDisabled]="isInvalidPosition"
					[isLoading]="isLoadingClosePosition()"
					(clicked)="onClosePositionOption()"
				>
					{{ 'closeOption.closePosition' | translate }}
				</app-button>
			</div>
		</div>
	}
</div>
